// Tecla do totem com resposta ao toque: encolhe e clareia por ~180 ms a cada
// pressão (Web Animations API, direto no elemento — não remonta o botão, então
// o clique continua chegando). Pedido do dono (09/09/2026): "animação ao clicar
// em cada tecla para passar suavidade e resposta enquanto digita".
import { useRef } from "react";

// `scale` (propriedade individual) e nao `transform`: animar `transform` apaga
// o translate que o elemento ja tem (o apagar do campo usa -translate-y-1/2),
// o botao pulava 28px no toque e o ponteiro "saia" dele — o clique nao completava.
const PRESSAO = [
  { scale: "0.86", filter: "brightness(1.7)" },
  { scale: "1.05", filter: "brightness(1.25)", offset: 0.6 },
  { scale: "1", filter: "brightness(1)" },
];
const OPCOES = { duration: 180, easing: "ease-out" };

// `onHold`: segurar a tecla por `holdMs` dispara a ação de segurar (ex.: apagar
// tudo) e o clique que vem ao soltar é engolido.
const HOLD_MS = 2000;

export default function Tecla({ children, onPress, onHold, holdMs = HOLD_MS, className = "", disabled = false, ...rest }) {
  const holdRef = useRef(null);
  const segurouRef = useRef(false);

  const animar = (e) => {
    if (disabled) return;
    try { e.currentTarget.animate(PRESSAO, OPCOES); } catch (_) { /* navegador sem WAAPI: fica sem animação */ }
    if (onHold) {
      segurouRef.current = false;
      clearTimeout(holdRef.current);
      holdRef.current = setTimeout(() => { segurouRef.current = true; onHold(); }, holdMs);
    }
  };
  const soltar = () => { clearTimeout(holdRef.current); };
  const clicar = (e) => {
    if (segurouRef.current) { segurouRef.current = false; return; }
    onPress?.(e);
  };
  return (
    <button
      type="button"
      disabled={disabled}
      onPointerDown={animar}
      onPointerUp={soltar}
      onPointerLeave={soltar}
      onPointerCancel={soltar}
      onClick={clicar}
      style={{ touchAction: "manipulation" }}
      className={`select-none transition-colors ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
